import React from 'react';

// import components
import {
  Banner,
  Crisp,
  HomeFinancing,
  Layout,
  LoansExplained,
  MortgageOptions,
  // ProgramBenefits,
  PropertyOptions,
  Reviews,
  SEO,
} from '../components';

const IndexPage = () => (
  <Layout>
    <SEO title="Home" />
    <Crisp />
    <Banner />
    <MortgageOptions />
    <PropertyOptions />
    <HomeFinancing />
    {/* <ProgramBenefits /> */}
    <LoansExplained />
    <Reviews />
  </Layout>
);

export default IndexPage;
